import { render } from "./CameraLookupTable.vue?vue&type=template&id=5b3dc73b&ts=true"
import script from "./CameraLookupTable.vue?vue&type=script&lang=tsx"
export * from "./CameraLookupTable.vue?vue&type=script&lang=tsx"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__